import { render } from "./SectionHeading.vue?vue&type=template&id=52c3ec27"
import script from "./SectionHeading.vue?vue&type=script&lang=js"
export * from "./SectionHeading.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/aryeo/aryeo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__